import styled from 'styled-components'

import { Layout, Text } from '@loadsmart/miranda-react'
import { toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { formatDate, parseISO } from 'core/utils/date'

type ScheduleBannerProps = {
  scheduleAt?: string | null
  facilityName?: string | null
}

const Stack = styled(Layout.Stack)`
  background: ${toCSSValue('color-background-tertiary')};
  border-radius: 8px;
  padding: ${toCSSValue('spacing-2')};
`

export function ScheduleBanner({ scheduleAt, facilityName }: ScheduleBannerProps) {
  if (!scheduleAt || !facilityName) {
    return null
  }

  return (
    <Stack>
      <Layout.Group justify="space-between">
        <Text color="color-text-link" variant="body-sm-bold">
          Schedule at
        </Text>
        <Text variant="body-sm" color="color-text-secondary">
          {formatDate(parseISO(scheduleAt), 'EEE, MMMM dd')} • Any available time (APPT - Live) in{' '}
          {facilityName}
        </Text>
      </Layout.Group>
    </Stack>
  )
}
